import Paper from '@mui/material/Paper';
import {styled} from '@mui/material/styles';

const Container = styled(Paper)(({theme}) => ({
  backgroundColor: theme.palette.grey[700],
  width: theme.mixins.sideNav.width,
  height: '100%',
  position: 'relative',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  zIndex: theme.zIndex.drawer + 1,
  backgroundImage: 'none',
}));

Container.defaultProps = {
  square: true,
};

export default Container;
